module.exports = __webpack_public_path__ + "static/media/spa.33bb7ad3.svg";